import { render, staticRenderFns } from "./OpeningSubject.vue?vue&type=template&id=4f6edd54&scoped=true"
import script from "./OpeningSubject.vue?vue&type=script&lang=js"
export * from "./OpeningSubject.vue?vue&type=script&lang=js"
import style0 from "./OpeningSubject.vue?vue&type=style&index=0&id=4f6edd54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6edd54",
  null
  
)

export default component.exports